import React from "react";

export const Footer: React.FC = () => {
  return (
    <footer className="py-12 px-6 bg-zinc-950 border-t border-white/5">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-8 opacity-60 hover:opacity-100 transition-opacity">
        <div className="text-sm font-heading font-bold tracking-widest uppercase text-white">
          FlirtMachine
        </div>
        <div className="flex gap-8 text-xs tracking-widest uppercase text-zinc-500">
          <a href="#" className="hover:text-primary transition-colors">
            Privacy
          </a>
          <a href="#" className="hover:text-primary transition-colors">
            Terms
          </a>
          <a href="#methodology" className="hover:text-primary transition-colors">
            Methodology
          </a>
        </div>
        <div className="text-xs text-zinc-700 uppercase tracking-widest">© 2024 FM Inc.</div>
      </div>
    </footer>
  );
};
